import React from 'react';
import './SeparatorLine.css';

type SeparatorLineProps = {};

export const SeparatorLine: React.FC<SeparatorLineProps> = () => {
  return <div className="separator-line--line" />;
};
